"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOrderContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../../assets/styles/config");
exports.StyledOrderContainer = styled_components_1.default.div `
  background: ${config_1.colors.white};
  border-radius: 6px;
  filter: drop-shadow(0 0 0.1rem ${config_1.colors.grayDropShadow});
  margin: 20px;
`;
